import React from "react";
import { Radio, Sparkles, ArrowRight } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// The redirect target must come from the browser's live location so the auth loop returns to the
// exact origin the user is currently on (preview / prod / localhost). Any fallback creates a
// mismatch that Emergent-Auth silently rejects with a 400 or 404.
const startGoogleAuth = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const Login = () => {
    return (
        <div className="min-h-screen bg-meye-bg text-zinc-100 flex items-center justify-center p-6 relative overflow-hidden">
            {/* ambient gradient wash */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-meye-fuchsia/25 blur-[120px]" />
                <div className="absolute -bottom-40 -right-40 w-[520px] h-[520px] rounded-full bg-meye-cyan/25 blur-[120px]" />
            </div>

            <div className="relative w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center gap-2">
                        <Radio className="w-9 h-9 text-meye-fuchsia" strokeWidth={2} />
                        <h1 className="font-brand text-4xl font-extrabold bg-gradient-to-r from-meye-fuchsia via-violet-400 to-meye-cyan bg-clip-text text-transparent">
                            mEYEtasks
                        </h1>
                    </div>
                    <p className="mt-3 text-sm text-zinc-400 font-mono">
                        your calm, proactive assistant for tasks &amp; rituals
                    </p>
                </div>

                <div className="rounded-2xl border border-meye-border bg-meye-card/80 backdrop-blur-md p-6 space-y-5">
                    <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-meye-cyan font-mono">
                        <Sparkles size={12} strokeWidth={2} />
                        14-day free trial · no credit card
                    </div>

                    <button
                        onClick={startGoogleAuth}
                        className="w-full flex items-center justify-center gap-3 px-4 py-3.5 rounded-xl bg-white text-zinc-900 font-brand font-bold text-sm hover:bg-zinc-100 transition-colors shadow-[0_0_18px_rgba(255,255,255,0.15)]"
                        data-testid="login-google-btn"
                    >
                        <GoogleLogo />
                        Continue with Google
                        <ArrowRight size={15} strokeWidth={2.5} />
                    </button>

                    <div className="flex items-center gap-3 text-[10px] text-zinc-600 font-mono uppercase tracking-widest">
                        <div className="flex-1 h-px bg-meye-border" />
                        <span>email fallback</span>
                        <div className="flex-1 h-px bg-meye-border" />
                    </div>

                    <button
                        disabled
                        title="Coming in Phase 1b"
                        className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-meye-border bg-black/30 text-zinc-500 font-brand font-bold text-sm cursor-not-allowed"
                        data-testid="login-email-btn"
                    >
                        Email + password — coming soon
                    </button>
                </div>

                <p className="text-center text-[10px] text-zinc-600 mt-6 font-mono uppercase tracking-widest">
                    by continuing you agree to be nagged about your rituals
                </p>
            </div>
        </div>
    );
};

const GoogleLogo = () => (
    <svg width="17" height="17" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
);

export default Login;
